import { useI18n } from "@/shared/composables/use-i18n";
import { setup } from "vue-class-component";
import { Composer } from "vue-i18n";
import { Prop, Vue } from "vue-property-decorator";
import { AppDropdownOptionDetails, AppDropdownOptionValue } from "./app-dropdown";
import { theme } from "@/themes";

export type AppDropdownSelectedProps = {
    // NOTE: In `single-optional` mode it can contain single element or can be empty.
    // NOTE: In `single` mode it will always contain single element.
    selectedValues: ReadonlyMap<AppDropdownOptionValue, AppDropdownOptionDetails>;
    isAllSelected: boolean;
    placeholder: string;
    formatValue: (
        values: ReadonlyMap<AppDropdownOptionValue, AppDropdownOptionDetails>,
        placeholder: string,
        isAllSelected: boolean,
        i18n: Composer,
    ) => string;
    removeOption?: (option: AppDropdownOptionDetails) => void;
    showSelectedAsBox?: boolean;
};

export const defaultFormatValue = (
    selectedValues: ReadonlyMap<AppDropdownOptionValue, AppDropdownOptionDetails>,
    placeholder: string,
    isAllSelected: boolean,
    i18n: Composer,
) => {
    if (isAllSelected && selectedValues.size !== 1) {
        return i18n.t("myOrders.all");
    }

    switch (selectedValues.size) {
        case 0:
            return placeholder;
    }

    return [...selectedValues.values()].map((it) => it.label).join(", ");
};

export class AppDropdownSelectedComponent extends Vue {
    @Prop()
    tabindex?: number;

    @Prop()
    fontSize?: string;

    @Prop({ required: true })
    selectedValues!: AppDropdownSelectedProps["selectedValues"];

    @Prop({ required: true })
    placeholder!: string;

    @Prop({ default: defaultFormatValue, type: Function })
    formatValue!: AppDropdownSelectedProps["formatValue"];

    @Prop({ required: true, type: Boolean })
    isAllSelected!: boolean;

    @Prop({ default: false, type: Boolean })
    showSelectedAsBox!: boolean;

    @Prop({ default: () => {}, type: Function })
    removeOption!: (value: AppDropdownOptionValue) => void;

    i18n = setup(useI18n);

    get formattedValue(): string {
        return this.formatValue(
            this.selectedValues,
            this.placeholder,
            this.isAllSelected,
            this.i18n as unknown as Composer,
        );
    }

    get fontFamily() {
        return theme.fonts["font-family"];
    }
}

export default AppDropdownSelectedComponent;
